module.exports = __webpack_public_path__ + "img/telkie.eb776db5.jpg";